export default __webpack_public_path__ + "static/media/SourceSansPro-Regular.3bb9538c.svg";